import { render, staticRenderFns } from "./EvolucionPaciente.vue?vue&type=template&id=302faa9e"
import script from "./EvolucionPaciente.vue?vue&type=script&lang=js"
export * from "./EvolucionPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports